import React from 'react'
import { TitleContainer, Text } from './Title.style'
import BackRoute from '@components/BackRoute/BackRoute.component'

export const Title = ({ text, onBackClick }: { text: string; onBackClick?: () => void }) => {
    return (
        <TitleContainer>
            {onBackClick && <BackRoute onlyIcon={true} onBackClick={onBackClick} />}
            <Text>{text}</Text>
        </TitleContainer>
    )
}
